import {
  AGENT_GROUPS,
  AGENTS,
  PROFILE,
  SMS_CHANNELS,
  TENANTS,
  EMAIL_CHANNELS,
  PHONE_CHANNELS,
  QUEUES,
} from "./constants";

/**
 * Build endpoint for tenant REST endpoints.
 * The /customer/:customer-id part is already included.
 *
 * @return {String} tenants base URL
 */
export const tenantsBaseUrl = (tenantName) => `${TENANTS}/${tenantName}`;

export const agentGroupsPath = (tenantName) =>
  `${tenantsBaseUrl(tenantName)}/${AGENT_GROUPS}`;

export const emailChannelsPath = (tenantName) =>
  `${tenantsBaseUrl(tenantName)}/${EMAIL_CHANNELS}`;

export const phoneChannelsPath = (tenantName) =>
  `${tenantsBaseUrl(tenantName)}/${PHONE_CHANNELS}`;

export const tenantProfilePath = (tenantName) =>
  `${tenantsBaseUrl(tenantName)}/${PROFILE}`;

export const queuesBasePath = (tenantName) =>
  `${tenantsBaseUrl(tenantName)}/${QUEUES}`;

/**
 * Build the path to the TAP-VCCSS controller for agents.
 *
 * @param tenantName tenant name
 * @param groups list of {@see src/react/features/vcc/types/agents/apiGroups.js}
 *  that control
 * @returns {string}
 */
export const agentsPath = (tenantName, groups) => {
  const baseUrl = `${tenantsBaseUrl(tenantName)}/${AGENTS}`;
  if (groups?.length) {
    // Do not url-encode the group enumeration, the commas need to stay
    const commaJoinedGroups = groups.join(",");
    return `${baseUrl}?groups=${commaJoinedGroups}`;
  }

  return baseUrl;
};

export const smsChannelsPath = (tenantName) =>
  `${tenantsBaseUrl(tenantName)}/${SMS_CHANNELS}`;
